import { DateHeaderProps } from 'react-big-calendar';
import dayjs from "dayjs";
import React from "react";
import {scale} from "../../../utils";
import theme, {FONTS} from "../../../constants/theme";
import {useMediaQuery} from "@mui/system";

interface Props extends DateHeaderProps {
  label: string,
  date: Date,
  currentDate: Date
}

const DateHeaderComponent: React.FC<Props> = ({ label, date, currentDate }: Props) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isCurrentMonth = dayjs(date).isSame(dayjs(currentDate), 'month');
  const today = dayjs();
  const thisDate = dayjs(date);
  const viewedMonth = dayjs(currentDate);

  const isToday =
    today.isSame(thisDate, 'day') &&
    today.month() === viewedMonth.month() &&
    today.year() === viewedMonth.year();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: isMobile ? scale(85) : scale(171),
      height: scale(20),
      color: isCurrentMonth ? '#000' : '#aaa',
      fontWeight: 'normal',
      fontFamily: FONTS.MONTSERRAT,
      fontSize: scale(14),
      marginTop: scale(6),
      marginBottom: isMobile ? scale(5) : scale(3),
    }}>
      {isToday ? (
        <div
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.primary,
            borderRadius: '50%',
            width: scale(25),
            height: scale(25),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
          }}
        >
          {label}
        </div>
      ) : (
        label
      )}
    </div>
  );
};

export default DateHeaderComponent;
